import styled from 'styled-components';

export const DonutChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
